<template lang="pug">
  div
    div.mt-20
      p.margin-medium-top.label {{isEstadoMA ? 'Boleto' : 'DAE'}}
      app-display(label="Tipo:", :content="tipoPagamento()")
      el-row(
        type="flex",
        justify="left",
        align="bottom"
      )
        app-display.mr-20(label="Valor principal:", v-if="!isParcelado()", :content="formatValorPrincipalAVista()")
        app-display.mr-20(label="Valor do desconto:", v-if="!isParcelado()", :content="formatValorDesconto()")
        app-display.mr-20(label="Valor líquido:", v-if="!isParcelado()", :content="formatValorTotalAVista()")
        app-display.mr-20(label="Valor principal:", v-if="isParcelado()", :content="formatValorPrincipalParcelado()")
        app-display.mr-20(label="Valor do juros:", v-if="isParcelado()", :content="formatValorJuros()")
        app-display.mr-20(label="Valor total:", v-if="isParcelado()", :content="formatValorTotal()")

      .divider.mt-20
      el-row.mb-15(v-if="podeRepacelar", type="flex")
        el-button(type="warning", size="small", @click="irParaReparcelamento") Repacelar saldo em aberto
      el-row
        el-table(
          stripe
          :data='parcelas',
        )
          el-table-column(type='expand')
            template(slot-scope='props')
              div(v-if="props.row.boletos.length > 0")
                div(v-for="(boleto, index) in props.row.boletos")
                  el-row(
                    type="flex",
                    justify="space-between",
                    align="bottom"
                  )
                    p.label {{props.row.boletos.length - index + 'ª via'}}

                    el-tooltip.item(
                      effect='dark',
                      :content="'Baixar DAE'",
                      placement="left"
                    )
                      el-button.btn(
                        type="text",
                        @click="downloadBoleto(boleto)",
                        size="mini",
                      )
                        span
                          font-awesome-icon.icon(icon="file-pdf" size="2x")

                  el-row.divider

                  app-display(label="Valor Total:", :content="formatValor(boleto.valorPrincipal)")
                  app-display(label="Situação:", :content="getSituacaoVia(boleto.situacao)")
                  app-display(label="Data de emissão:", :content="boleto.dataCalculo")
                  app-display(label="Vencimento:", :content="boleto.dataVencimento")
              div(v-else)
                el-row(
                  type="flex",
                  justify="center",
                  align="bottom"
                )
                  span {{ 'Parcela não emitida' }}

          el-table-column(
            label='Parcela'
            :formatter="formatLabelParcelas"
          )

          el-table-column(
            label='Situação parcela'
            prop="situacaoParcela"
            :formatter="formatSituacaoParcela"
          )

          el-table-column(
            label='Valor',
            prop="valorPrincial"
            :formatter="formatMoneyProp"
          )

          el-table-column(
            label='Status'
            prop="situacao"
            :formatter="getSituacaoBoleto"
          )

          el-table-column(
            label='Data de vencimento'
            prop="boletos"
            :formatter="formatDataVencimentoProp"
          )

          el-table-column(
            label='Data de Emissão'
            prop="boletos"
            :formatter="formatDataEmissaoProp"
          )

          el-table-column(
            :label="acoesDropdown.titulo",
            :prop="acoesDropdown.propriedade",
            align="center",
            header-align="center",
            width="150"
          )
            template(slot-scope="scope", v-if="scope.row.emitido && scope.row.situacaoParcela !== 'CANCELADO'")
              el-dropdown(trigger="click", size="small")
                el-button(type="primary", size="mini")
                  | Ações
                  i.el-icon-arrow-down.el-icon--right
                el-dropdown-menu(slot="dropdown")
                  el-dropdown-item
                    div(
                      v-if="scope.row.isVencido"
                      @click="reemitir(scope.row.id)"
                    )
                      i.fa(
                        :class="'fa-file-invoice-dollar'"
                      )
                      | &nbsp Reemitir boleto
                    .disabled-content(v-else)
                      i.fa(
                        :class="'fa-file-invoice-dollar'"
                      )
                      | &nbsp Reemitir boleto
                  el-dropdown-item
                    div(
                      v-if="!scope.row.isPaga"
                      @click="editar(scope.row)"
                    )
                      i.fa(
                        :class="'fa-edit'"
                      )
                      | &nbsp Editar boleto
                    .disabled-content(v-else)
                      i.fa(
                        :class="'fa-edit'"
                      )
                      | &nbsp Editar boleto

</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import AppDisplay from '@/components/AppDisplay'
import AppDivider from '@/components/AppDivider'
import AppNotificacao from '@/components/mixins/AppNotificacao'

export default {

  components: {
    AppDisplay,
    AppDivider
  },

  mixins: [
    AppNotificacao
  ],

  data () {
    return {
      acoesDropdown: {
        id: 0, titulo: 'Ações', propriedade: 'tipo', //eslint-disable-line
        acoes: [
          {id: 1, nome: 'Reemitir boleto', icone: 'fa-file-invoice-dollar', codigo: 'EMITIR_DAE', ordem: 1, show: this.showEmitirDae},
          {id: 2, nome: 'Editar boleto', icone: 'fa-edit', codigo: 'EDITAR_DAE', ordem: 1, show: this.showEditarDae}
        ]
      }
    }
  },

  props: {
    parcelas: {
      type: Array
    },
    numeroProcesso: {
      type: String,
      default: null
    },
    idProcesso: {
      type: [Number, String],
      default: null
    },
    isVoltar: {
      type: Boolean,
      default: false
    },
    tipoProcesso: {
      type: String,
      default: null
    }
  },

  computed: {
    calculoValorTotal () {
      let valor = 0
      if (!this.parcelas) return 0
      this.parcelas.forEach(p => {
        if (p.situacaoParcela !== 'CANCELADO' && p.valor != null) {
          valor += p.valor
        }
      })
      return valor
    },
    isEstadoMA () {
      return process.env.ESTADO === 'ma'
    },
    podeRepacelar () {
      if (!this.isEstadoMA || !this.numeroProcesso || !this.parcelas || !this.parcelas.length) return false
      return this.parcelas.some(p => p.situacaoParcela !== 'CANCELADO' && !p.isPaga)
    }
  },

  methods: {
    ...mapActions({
      getBoletosByProcesso: 'dae/getBoletosByProcesso',
      downloadDae: 'dae/downloadDae',
      reemitirDae: 'dae/reemitirDae'
    }),
    reemitir (id) {
      this.$emit('reemitirDae', {
        id
      })
    },

    editar (boleto) {
      let boletoEditar = boleto.boletos.filter(b => b.situacao !== 'CANCELADO' && b.situacao !== 'QUITADO')
      if (this.isParcelado()) {
        this.$emit('editarDae', {
          id: boleto.id,
          valorPrincipal: boletoEditar[0].valorPrincipal,
          isParcelado: boletoEditar[0].receita.isParcelado,
          taxaJurosPercentual: boleto.taxaJurosPercentual != null ? boleto.taxaJurosPercentual : 12,
          jurosPeriodicidadeMensal: !!boleto.jurosPeriodicidadeMensal
        })
      } else {
        this.$emit('editarDae', {
          id: boleto.id,
          valorPrincipal: boletoEditar[0].valorPrincipal + this.parcelas[0]?.desconto,
          desconto: this.parcelas[0]?.desconto
        })
      }
    },

    isParceladoSeguro () {
      if (!this.parcelas || !this.parcelas.length) return false
      const ref = this.parcelas.find(p => p.situacaoParcela !== 'CANCELADO' && p.boletos && p.boletos.length)
      if (!ref || !ref.boletos[0].receita) return false
      return ref.boletos[0].receita.isParcelado
    },
    isParcelado () {
      return this.isParceladoSeguro()
    },

    tipoPagamento () {
      return this.isParcelado() ? 'À Prazo' : 'À vista'
    },

    formatValor (valor) {
      return valor ? valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) : null
    },

    formatValorTotal () {
      return this.formatValor(this.calculoValorTotal)
    },

    formatValorTotalAVista () {
      const p = this.parcelas.find(x => x.situacaoParcela !== 'CANCELADO')
      const d = p && p.desconto != null ? p.desconto : 0
      return this.formatValor(this.calculoValorTotal - d)
    },

    formatValorDesconto () {
      const p = this.parcelas.find(x => x.situacaoParcela !== 'CANCELADO')
      return this.formatValor(p && p.desconto != null ? p.desconto : 0)
    },

    formatValorPrincipalAVista () {
      return this.formatValor(this.calculoValorTotal)
    },

    formatValorJuros () {
      const p = this.parcelas.find(x => x.situacaoParcela !== 'CANCELADO')
      return this.formatValor(p && p.juros != null ? p.juros : 0)
    },

    formatValorPrincipalParcelado () {
      const p = this.parcelas.find(x => x.situacaoParcela !== 'CANCELADO')
      const j = p && p.juros != null ? p.juros : 0
      return this.formatValor(this.calculoValorTotal - j)
    },

    formatLabelParcelas (prop) {
      if (this.isParcelado()) {
        if (prop.numeroParcela == null) {
          return '-'
        }
        return prop.numeroParcela === 1 ? 'Entrada' : `${prop.numeroParcela}ª parcela`
      } else if (!this.isParcelado() && this.parcelas.length > 1) {
        return prop.numeroParcela === 1 ? 'Parcela única' : '-'
      }
      return 'Parcela única'
    },

    async downloadBoleto (boleto) {
      await this.downloadDae(boleto.receita.id)
    },

    reemitirBoleto (id) {
      this.confirmBox(this.isEstadoMA ? this.$messages.CONFIRMAR_BOLETO.replace('DAE', 'Boleto') : this.$messages.CONFIRMAR_BOLETO,
        this.$messages.TITULO_WARNING,
        () => {
          this.reemitirDae(id).then(() => {
            this.showNotificacao(this.$messages.TIPO_SUCCESS, this.$messages.TITULO_SUCCESS,
              this.tipoProcesso === 'REURB_INDIVIDUAL' ? this.$messages.BOLETO_SUCCESS_REURB_INDIVIDUAL : this.$messages.BOLETO_SUCCESS)
            this.$router.push({
              name: 'DAE'
            })
          }).catch((error) => {
            this.showNotificacao(
              this.$messages.TIPO_ERROR,
              this.$messages.TITULO_ERROR,
              error.message
            )
          })
        },
        () => {})
    },
    formatSituacaoParcela (row) {
      const labels = {
        CRIADA: 'Criada',
        BOLETO_EMITIDO: 'Boleto emitido',
        CANCELADO: 'Cancelada'
      }
      const s = row.situacaoParcela
      return s ? (labels[s] || s) : '-'
    },

    formatMoneyProp (prop) {
      return this.formatValor(prop.valor)
    },

    getSituacaoBoleto (prop) {
      if (prop.situacaoParcela === 'CANCELADO') {
        return 'Cancelada'
      }
      if (prop.emitido && prop.isPaga) {
        return 'Pago'
      } else if (prop.emitido && !prop.isVencido) {
        return 'Aguardando pagamento'
      } else if (prop.emitido && prop.isVencido) {
        return 'Vencido'
      } else if (!prop.emitido) {
        return 'Aguardando emissão do boleto'
      } else {
        return 'Cancelado'
      }
    },

    getSituacaoVia (status) {
      if (status === 'VENCIDO') {
        return 'Vencido'
      } else if (status === 'AGUARDANDO_PAGAMENTO') {
        return 'Aguardando pagamento'
      } else if (status === 'QUITADO') {
        return 'Pago'
      } else {
        return 'Cancelado'
      }
    },

    formatData (data) {
      return data ? moment(data).format('DD/MM/YYYY') : '-'
    },

    formatDataVencimentoProp (props) {
      return props.emitido ? props.boletos[0].dataVencimento : '-'
    },

    formatDataEmissaoProp (props) {
      return props.emitido ? props.boletos[0].dataCalculo : '-'
    },

    irParaReparcelamento () {
      this.$emit('irReparcelamento')
    },
    voltar () {
      this.$router.push({
        name: 'caixa-entrada-cof'
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.label {
  font-weight: bold;
}

.divider {
  border: 1px solid #dfe4ed;
  margin-bottom: 10px;
}

.btn {
  padding: 5px;
  color: #33b281;
}

.mt-20 {
  margin-top: 20px;
}

.mr-20 {
  margin-right: 20px !important;
}

.disabled-content {
  opacity: 0.4;
  cursor: default;
}

>>> .el-table__row {
  &:last-child {
    font-weight: normal;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AppPagamentoMa.vue